module.exports = __webpack_public_path__ + "toBride2-we-w-g.e2974087.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-w-g.jpg
// module id = 73yP
// module chunks = 0